export class ProcessModel {
	id?: number = undefined;
	name: string = '';
	isActive: boolean = false;
	description: string|null = null;
	createdAt: Date|string;
	deletedAt: Date|string|null;

	constructor(p?:Partial<ProcessModel>) {
		Object.assign(this, p)
	}
}
